import BaseLayout from 'content/layouts/BaseLayout';
import { RouteObject } from 'react-router-dom';

const commonRouter: RouteObject = {
  path: '/',
  element: <BaseLayout />,
};

export default commonRouter;
